<template>
  <div>
    <div v-html="text" v-if="!loading"></div>
    <spinner v-if="loading" />
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import cug from "../services/cug";
import Spinner from "./shared/Spinner";

export default {
  name: "Text",
  mixins: [LocaleMixin],
  components: { Spinner },

  props: {
    type: String,
    required: true
  },

  data() {
    return {
      text: "",
      loading: true
    };
  },

  beforeMount() {
    cug
        .text(`text_${this.type}`, this.getLocale())
        .then(rep => {
          this.text = rep.data.content;
        })
        .catch(err => {
          this.$root.$emit("OsvAlert_ErrorFromApi", err, "text");
        })
        .finally(() => {
          this.loading = false;
        });
  }
};
</script>

<style lang="scss">
@import "../assets/styles/helpers.scss";

p {
  text-align: justify;
}
</style>
